goog.module('yext.spark.admin.tab.init');
goog.module.declareLegacyNamespace();

/**
 * Initializes tabs for sales channel rule admin pages
 */
const init = function() {
  var activeTab = $('.js-selected-tab').closest('.js-tab-container').index();
  $('#tabs').tabs({
    'active': activeTab,
    'beforeActivate': function(event, ui) {
      var url = ui['newTab'].find('.js-tab-link').attr('href');
      if (url) {
        location.href = url;
        return false;
      }
      return true;
    },
  });
};
goog.exportSymbol('yext.spark.admin.tab.init', init);

exports = init;
